module.exports = __webpack_public_path__ + "static/media/100_14.595b8cbd.jpg";